var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnMinimum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-minimum",
    clipPath: "url(#clip0_1041_3302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9222 1.40807H10.6388V1.29002C10.6388 0.94807 10.4931 0.619816 10.2321 0.377938C9.97188 0.13606 9.61947 0 9.25079 0H6.74909C5.9823 0 5.36113 0.577338 5.36113 1.29002V1.40807H5.07764C3.65405 1.40807 2.5 2.48069 2.5 3.80382V13.6043C2.5 14.9274 3.65405 16 5.07764 16H10.9224C12.3459 16 13.5 14.9274 13.5 13.6043V3.80382C13.5 2.48069 12.3458 1.40807 10.9222 1.40807ZM6.56007 1.29002C6.56007 1.18851 6.64914 1.10573 6.75835 1.10573H9.25073C9.3034 1.10573 9.35374 1.12516 9.39092 1.15972C9.4281 1.19427 9.44901 1.24107 9.44901 1.29002V1.40807H6.55075L6.56007 1.29002ZM5.0869 2.5138H10.9223C11.6891 2.5138 12.3103 3.09114 12.3103 3.80382V10.8068H3.68962V3.80382C3.68962 3.46187 3.83524 3.13362 4.09548 2.89174C4.35573 2.64986 4.70892 2.5138 5.07758 2.5138H5.0869Z",
    fill: "#A0A3A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_3302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMinimum);
export default __webpack_public_path__ + "static/media/icn_minimum.6890189b63ae853b2bf14164ced21572.svg";
export { ForwardRef as ReactComponent };